import React from 'react';
import { IconButton } from '@material-ui/core';
import { ArrowForward, Clear, GetApp } from '@material-ui/icons';
import { InvoiceActionRendererProps } from './types';

const InvoiceActionRenderer = ({ data }: InvoiceActionRendererProps) => (
  <IconButton
    size="small"
    onClick={() => window.open(data.hosted_invoice_url, '_blank')}
  >
    <ArrowForward />
  </IconButton>
);

export default InvoiceActionRenderer;
